import { Button, Typography } from "@lyfegen-platform/react-common";
import { Backdrop, Box, Card, useTheme, withStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const StyledBackdrop = withStyles({
	root: {
		zIndex: 99999,
		backgroundColor: "rgba(28, 49, 69, 0.4)",
		backdropFilter: "blur(7px)",
	},
})(Backdrop);

function AppBackdrop(props: { open: boolean }) {
	const { t } = useTranslation();
	const { spacing } = useTheme();

	return (
		<StyledBackdrop open={props.open} invisible>
			<Card>
				<Box margin={3} padding={3} display="flex" flexDirection="column" alignItems="center">
					<Typography variant="subtitle1" style={{ marginBottom: spacing(3), color: "#212121" }}>
						{t("session-expired-refresh")}
					</Typography>
					<Button color="primary" use="primary" style={{ fontSize: "12px" }} onClick={() => window.location.reload()}>
						{t("refresh")}
					</Button>
				</Box>
			</Card>
		</StyledBackdrop>
	);
}

export default AppBackdrop;
